import * as React from 'react';
import { useTranslation } from 'react-i18next';
import cn from 'classnames';

import { BaseButton, ModalX } from '../../../../../BaseComponents';
import { useToggleable } from '../../../../../hooks';
import { useTheme } from '../../../../../theme';
import { useCancelOrder } from '../../lib/useCancelOrder';
import { CdnIcon } from '@shared/ui';

interface Props {
	orderId: string;
	className?: string;
}

const CancelOrderConfirm: React.FC<Props> = ({ orderId, className }) => {
	const { t } = useTranslation('Checkout');
	const { CancelOrderConfirm: theme } = useTheme('Features').CancelOrder;

	const { isOpen, open, close } = useToggleable(false);

	const { onCancelOrder, cancelOrderResult } = useCancelOrder();

	const onCancelOrderHandler = async () => {
		await onCancelOrder({ id: orderId });
		close();
	};

	return (
		<>
			<BaseButton variant="optionEdit" className={cn(theme.cancelButton, className)} onClick={open}>
				{t('Cancel order')}
			</BaseButton>
			<ModalX isOpen={isOpen}>
				<div className={theme.content}>
					<div className={theme.title}>
						<div className={theme.icon}>
							<CdnIcon icon="Info/Warning" />
						</div>
						{t('Are you sure you want to cancel the order?')}
					</div>
					<div className={theme.buttons}>
						<BaseButton
							variant="action"
							className={theme.button}
							onClick={onCancelOrderHandler}
							isLoading={cancelOrderResult.loading}
						>
							{t('Cancel order')}
						</BaseButton>
						{!cancelOrderResult.loading && (
							<BaseButton variant="secondary" className={theme.button} onClick={close}>
								{t('Close')}
							</BaseButton>
						)}
					</div>
				</div>
			</ModalX>
		</>
	);
};

export default CancelOrderConfirm;
